var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 787,
    height: 800,
    viewBox: "0 0 787 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.122 140.298C272.802 140.298 290.381 122.731 290.381 101.027V39.2469C290.381 17.5812 272.802 0 251.122 0C229.442 0 211.848 17.5812 211.848 39.2469V101.025C211.848 122.731 229.442 140.298 251.122 140.298Z",
    fill: "#9A7D62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540.639 140.298C562.306 140.298 579.899 122.731 579.899 101.027V39.2469C579.899 17.5812 562.305 0 540.639 0C518.959 0 501.366 17.5812 501.366 39.2469V101.025C501.364 122.731 518.959 140.298 540.639 140.298Z",
    fill: "#9A7D62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M676.68 55.9485H614.391V101.025C614.391 141.713 581.314 174.803 540.639 174.803C499.964 174.803 466.875 141.713 466.875 101.025V55.9485H324.873V101.025C324.873 141.713 291.783 174.803 251.123 174.803C210.448 174.803 177.358 141.713 177.358 101.025V55.9485H110.273C49.3719 55.9485 0 105.322 0 166.222V689.727C0 750.627 49.3719 800 110.273 800H676.68C737.58 800 786.953 750.627 786.953 689.727V166.222C786.953 105.322 737.58 55.9485 676.68 55.9485ZM733.295 689.727C733.295 720.942 707.895 746.344 676.678 746.344H110.273C79.0562 746.344 53.6562 720.942 53.6562 689.727V235.913H733.295V689.727Z",
    fill: "#9A7D62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M366.162 597.675H266.802V697.036H366.162V597.675Z",
    fill: "#9A7D62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.162 443.688H266.802V543.048H366.162V443.688Z",
    fill: "#9A7D62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.175 597.675H112.828V697.036H212.175V597.675Z",
    fill: "#9A7D62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.175 443.688H112.828V543.048H212.175V443.688Z",
    fill: "#9A7D62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M674.125 289.714H574.777V389.061H674.125V289.714Z",
    fill: "#9A7D62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M520.15 289.714H420.789V389.061H520.15V289.714Z",
    fill: "#9A7D62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M540.416 458.15L510.862 435.172L457.048 504.392L425.098 478.834L401.716 508.034L463.284 557.302L540.416 458.15Z",
    fill: "#9A7D62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M674.125 443.688H574.777V543.048H674.125V443.688Z",
    fill: "#9A7D62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M520.15 597.675H420.789V697.036H520.15V597.675Z",
    fill: "#9A7D62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366.162 289.714H266.802V389.061H366.162V289.714Z",
    fill: "#9A7D62"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.948f364258e3b6dcf47d32afa61cab3a.svg";
export { ForwardRef as ReactComponent };